<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="hissetinfo" :rules="rules" ref="syscalcrule" label-width="120px" class="">
			<el-row>
				<el-col :span="24">
					<el-form-item label="所属组织" prop="org">
						<el-cascader style="width: 100%;" :disabled="!editok" v-model="hissetinfo.orgids" 
							:options="allOrgTree" :props="orgtreePro" clearable @change="orgChange"></el-cascader>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="hissetinfo.orgid != ''">
				<el-col :span="24">
					<el-form-item label="总耗电(加)" prop="totalpowers">
						<el-select style="width: 100%;" filterable clearable  :disabled="!editok" v-model="hissetinfo.totalpowers"
							placeholder="请选择点位" multiple >
							<el-option v-for="item in orgpropertyList" :key="item.id" :label="item.devname +' | '+ item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="hissetinfo.orgid != ''">
				<el-col :span="24">
					<el-form-item label="空调耗电(加)" prop="airpowers">
						<el-select style="width: 100%;" filterable clearable  :disabled="!editok" v-model="hissetinfo.airpowers"
							placeholder="请选择点位" multiple >
							<el-option v-for="item in orgpropertyList" :key="item.id" :label="item.devname +' | '+ item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="hissetinfo.orgid != ''">
				<el-col :span="24">
					<el-form-item label="空调耗电(减)" prop="minsairpowers">
						<el-select style="width: 100%;" filterable clearable  :disabled="!editok" v-model="hissetinfo.minsairpowers"
							placeholder="请选择点位" multiple >
							<el-option v-for="item in orgpropertyList" :key="item.id" :label="item.devname +' | '+ item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="hissetinfo.orgid != ''">
				<el-col :span="24">
					<el-form-item label="照明耗电(加)" prop="lightpowers">
						<el-select style="width: 100%;" filterable clearable  :disabled="!editok" v-model="hissetinfo.lightpowers"
							placeholder="请选择点位" multiple >
							<el-option v-for="item in orgpropertyList" :key="item.id" :label="item.devname +' | '+ item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="hissetinfo.orgid != ''">
				<el-col :span="24">
					<el-form-item label="照明耗电(减)" prop="minslightpowers">
						<el-select style="width: 100%;" filterable clearable  :disabled="!editok" v-model="hissetinfo.minslightpowers"
							placeholder="请选择点位" multiple >
							<el-option v-for="item in orgpropertyList" :key="item.id" :label="item.devname +' | '+ item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="hissetinfo.orgid != ''">
				<el-col :span="24">
					<el-form-item label="其他耗电(加)" prop="otherpowers">
						<el-select style="width: 100%;" filterable clearable  :disabled="!editok" v-model="hissetinfo.otherpowers"
							placeholder="请选择点位" multiple >
							<el-option v-for="item in orgpropertyList" :key="item.id" :label="item.devname +' | '+ item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="hissetinfo.orgid != ''">
				<el-col :span="24">
					<el-form-item label="其他耗电(减)" prop="minsotherpowers">
						<el-select style="width: 100%;" filterable clearable  :disabled="!editok" v-model="hissetinfo.minsotherpowers"
							placeholder="请选择点位" multiple >
							<el-option v-for="item in orgpropertyList" :key="item.id" :label="item.devname +' | '+ item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveHisSet">保存</el-button>
		</div>
		
	</div>
</template>

<script> 
	import { addHisPowerSet, editHisPowerSet, queryOrgAllPropertys } from '/static/apiUrl.js'
	export default {
		name : 'HisSetDetail',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				hissetinfo : {
					id: "",
					orgid: "",
					orgids : [],
					totalpower : '',
					totalpowers : [],
					airpower: "",
					airpowers : [],
					lightpower: "",
					lightpowers : [],
					otherpower : '',
					otherpowers : [],
					minstotalpower : '',
					minstotalpowers : [],
					minsairpower: "",
					minsairpowers : [],
					minslightpower: "",
					minslightpowers : [],
					minsotherpower : '',
					minsotherpowers : [],
				},
				rules:{
					orgids: [
						{ required: true, message: '请选择组织', trigger: 'blur' }
					],
					totalpowers: [
						{ required: true, message: '请选择总耗电点位', trigger: 'blur' }
					],
					
				},
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				},
				orgpropertyList : [],
				
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectedhis: {
				type: Object,
				required: false
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			},
			allOrgTree : {
				type : Array,
				required: true
			},
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			allOrgTree : {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
				}
			},
			selectedhis: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.hissetinfo.id = newVal.id
						this.hissetinfo.orgid = newVal.orgid
						this.hissetinfo.orgids = newVal.orgid
						this.hissetinfo.totalpower = newVal.totalpower
						if(newVal.totalpower != null && newVal.totalpower.length > 0){
							this.hissetinfo.totalpowers = newVal.totalpower.split(',')
						}else{
							this.hissetinfo.totalpowers = []
						}
						
						this.hissetinfo.airpower = newVal.airpower
						if(newVal.airpower != null && newVal.airpower.length > 0){
							this.hissetinfo.airpowers = newVal.airpower.split(',')
						}else{
							this.hissetinfo.airpowers = []
						}
						
						this.hissetinfo.lightpower = newVal.lightpower
						if(newVal.lightpower != null && newVal.lightpower.length > 0){
							this.hissetinfo.lightpowers = newVal.lightpower.split(',')
						}else{
							this.hissetinfo.lightpowers = []
						}
						this.hissetinfo.otherpower = newVal.otherpower
						if(newVal.otherpower != null && newVal.otherpower.length > 0){
							this.hissetinfo.otherpowers = newVal.otherpower.split(',')
						}else{
							this.hissetinfo.otherpowers = []
						}
						
						this.hissetinfo.minstotalpower = newVal.minstotalpower
						if(newVal.minstotalpower != null && newVal.minstotalpower.length > 0){
							this.hissetinfo.minstotalpowers = newVal.minstotalpower.split(',')
						}else{
							this.hissetinfo.minstotalpowers = []
						}
						
						this.hissetinfo.minsairpower = newVal.minsairpower
						if(newVal.minsairpower != null && newVal.minsairpower.length > 0){
							this.hissetinfo.minsairpowers = newVal.minsairpower.split(',')
						}else{
							this.hissetinfo.minsairpowers = []
						}
						
						this.hissetinfo.minslightpower = newVal.minslightpower
						if(newVal.minslightpower != null && newVal.minslightpower.length > 0){
							this.hissetinfo.minslightpowers = newVal.minslightpower.split(',')
						}else{
							this.hissetinfo.minslightpowers = []
						}
						this.hissetinfo.minsotherpower = newVal.minsotherpower
						if(newVal.minsotherpower != null && newVal.minsotherpower.length > 0){
							this.hissetinfo.minsotherpowers = newVal.minsotherpower.split(',')
						}else{
							this.hissetinfo.minsotherpowers = []
						}
						this.initData()
					}else{
						this.hissetinfo.id = ''
						this.hissetinfo.orgid = ''
						this.hissetinfo.orgids = []
						this.hissetinfo.totalpower = ''
						this.hissetinfo.totalpowers = []
						this.hissetinfo.airpower = ''
						this.hissetinfo.airpowers = []
						this.hissetinfo.lightpower = ''
						this.hissetinfo.lightpowers = []
						this.hissetinfo.otherpower = ''
						this.hissetinfo.otherpowers = []
						this.hissetinfo.minstotalpower = ''
						this.hissetinfo.minstotalpowers = []
						this.hissetinfo.minsairpower = ''
						this.hissetinfo.minsairpowers = []
						this.hissetinfo.minslightpower = ''
						this.hissetinfo.minslightpowers = []
						this.hissetinfo.minsotherpower = ''
						this.hissetinfo.minsotherpowers = []
					}
				}
			},
		},
		methods: {
			initData(){
				if(this.hissetinfo.orgid != ''){
					this.orgpropertyList = []
					queryOrgAllPropertys({oid: this.hissetinfo.orgid}).then(res => {
						if(0 == res.code){
							this.orgpropertyList = res.datas
						}
					})
				}
				
			},
			orgChange(val){
				if(val){
					this.hissetinfo.orgid = val[val.length -1]
					this.initData()
				}
			},
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRefrash",false,false)
				}
			},
			saveHisSet(){
				this.$refs["syscalcrule"].validate((valid) => {
					if (valid) {
						if(this.hissetinfo.totalpowers.length > 0){
							this.hissetinfo.totalpower = this.hissetinfo.totalpowers.join(",")
						}
						if(this.hissetinfo.airpowers.length > 0){
							this.hissetinfo.airpower = this.hissetinfo.airpowers.join(",")
						}
						if(this.hissetinfo.lightpowers.length > 0){
							this.hissetinfo.lightpower = this.hissetinfo.lightpowers.join(",")
						}
						if(this.hissetinfo.otherpowers.length > 0){
							this.hissetinfo.otherpower = this.hissetinfo.otherpowers.join(",")
						}
						if(this.hissetinfo.minstotalpowers.length > 0){
							this.hissetinfo.minstotalpower = this.hissetinfo.minstotalpowers.join(",")
						}
						if(this.hissetinfo.minsairpowers.length > 0){
							this.hissetinfo.minsairpower = this.hissetinfo.minsairpowers.join(",")
						}
						if(this.hissetinfo.minslightpowers.length > 0){
							this.hissetinfo.minslightpower = this.hissetinfo.minslightpowers.join(",")
						}
						if(this.hissetinfo.minsotherpowers.length > 0){
							this.hissetinfo.minsotherpower = this.hissetinfo.minsotherpowers.join(",")
						}
						console.log(this.hissetinfo)
						if(this.hissetinfo.id != null && this.hissetinfo.id != ''){  //编辑
							editHisPowerSet(this.hissetinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "更新成功",
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}else{ //新增
							addHisPowerSet(this.hissetinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "添加成功",
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>